export const focusableSelectors = [
  'a[href]',
  'button',
  'textarea',
  'input:not([type="hidden"])',
  'select',
  '[tabindex]:not([tabindex="-1"])',
];
export function focusableFilter(el: Element): boolean {
  return !el.hasAttribute('disabled') && !el.hasAttribute('aria-hidden');
}

export function findFirstFocusable(el: HTMLElement): HTMLElement | undefined {
  const elements = el.querySelectorAll(focusableSelectors.join(','));
  return Array.from(elements).filter(focusableFilter)[0] as HTMLElement;
}
